(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["delivery-time-1"] && !Shopify.designMode) return;
  try {
    class DeliveryTime extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const deliveryStart = parseInt(this.dataset.deliveryStart) || 10;
      const deliveryEnd = parseInt(this.dataset.deliveryEnd) || 15;
      const excludeDays = this.dataset.excludeDays || 'SAT,SUN';
      const excludeMode = this.dataset.excludeMode || '1';
      const dateFormat = this.dataset.dateFormat || 'bee4, bee5 bee6';
      const cutoffTime = this.dataset.cutoffTime || '16:00:00';
      const textHours = this.dataset.textHours || 'hours';
      const textMinutes = this.dataset.textMinutes || 'minutes';
      const deliveryText = this.dataset.deliveryText || 'Order in the next [hour] to get it between [date_start] and [date_end]';

      const textContainer = this.querySelector('[data-delivery-text-container]');
      if (!textContainer) return;

      // Parse excluded days
      const excludedDays = excludeDays.split(',').map(d => d.trim().toUpperCase());
      const dayMap = { 'SUN': 0, 'MON': 1, 'TUE': 2, 'WED': 3, 'THU': 4, 'FRI': 5, 'SAT': 6 };
      const excludedDayNumbers = excludedDays.map(d => dayMap[d]).filter(d => d !== undefined);

      // Calculate delivery dates
      const now = new Date();
      const [cutHour, cutMin, cutSec] = cutoffTime.split(':').map(Number);
      const cutoffDate = new Date(now);
      cutoffDate.setHours(cutHour, cutMin, cutSec || 0, 0);

      // Check if past cutoff time
      let startDate = new Date(now);
      if (now > cutoffDate) {
        startDate.setDate(startDate.getDate() + 1);
      }

      // Calculate start delivery date (excluding specified days if mode is 2)
      let daysAdded = 0;
      let currentDate = new Date(startDate);
      while (daysAdded < deliveryStart) {
        currentDate.setDate(currentDate.getDate() + 1);
        if (excludeMode === '2' || !excludedDayNumbers.includes(currentDate.getDay())) {
          daysAdded++;
        }
      }
      const startDeliveryDate = new Date(currentDate);

      // Calculate end delivery date
      daysAdded = 0;
      currentDate = new Date(startDate);
      while (daysAdded < deliveryEnd) {
        currentDate.setDate(currentDate.getDate() + 1);
        if (excludeMode === '2' || !excludedDayNumbers.includes(currentDate.getDay())) {
          daysAdded++;
        }
      }
      const endDeliveryDate = new Date(currentDate);

      // Format dates
      const formatDate = (date, format) => {
        const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        
        const day = date.getDate();
        const suffix = (d) => {
          if (d > 3 && d < 21) return 'th';
          switch (d % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
          }
        };

        return format
          .replace('bee4', days[date.getDay()])
          .replace('bee5', day + suffix(day))
          .replace('bee6', months[date.getMonth()])
          .replace('DD', day.toString().padStart(2, '0'))
          .replace('MM', (date.getMonth() + 1).toString().padStart(2, '0'))
          .replace('YYYY', date.getFullYear());
      };

      const startFormatted = formatDate(startDeliveryDate, dateFormat);
      const endFormatted = formatDate(endDeliveryDate, dateFormat);

      // Update text with countdown
      const updateCountdown = () => {
        const now = new Date();
        let targetTime = new Date(now);
        targetTime.setHours(cutHour, cutMin, cutSec || 0, 0);

        if (now > targetTime) {
          targetTime.setDate(targetTime.getDate() + 1);
        }

        const diff = targetTime - now;
        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

        const countdownText = `<strong>${hours}</strong> ${textHours} <strong>${minutes}</strong> ${textMinutes}`;

        const finalText = deliveryText
          .replace('[hour]', countdownText)
          .replace('[date_start]', `<strong>${startFormatted}</strong>`)
          .replace('[date_end]', `<strong>${endFormatted}</strong>`);

        textContainer.innerHTML = finalText;
      };

      updateCountdown();
      setInterval(updateCountdown, 60000); // Update every minute
    }
  }

  if (!customElements.get('delivery-time')) {
    customElements.define('delivery-time', DeliveryTime);
  }
  } catch(e) { console.error(e); }
})();

})();
